// @flow

import React, { useCallback } from "react";
import { connect, useDispatch } from "react-redux";

import {
  type State,
  abrirExplicacaoQtLink,
  abrirPaginaArquivos,
  exportarExcelVinculado,
  exportarFuncaoQtlink,
  gerarRelatorio,
  getModoApp,
  limparSelecao,
} from "../../state";
import { type ModoApp, MODO_APP_SERIES, MODO_APP_NORMAL } from "../../model";
import { OkButton, IconButton, RejectButton } from "@quantum/ui";
import { Translate } from "@quantum/i18n";
import { RequiresPermission } from "@quantum/permission";

import { bindModalTrigger, useModal } from "../comum";

import IconeQuantumLink from "../../assets/icone_quantum_link.png";

import "./rodape.css";
import { useHistory } from "react-router";

export const BotaoTemplate = () => {
  const modalDeTemplates = useModal("templates");

  return (
    <RequiresPermission permission="TEMPLATE">
      <OkButton
        className="Rodape__botao Rodape__botao--template"
        {...bindModalTrigger(modalDeTemplates)}
      >
        <Translate>configuracaoRelatorio.botaoTemplates</Translate>
      </OkButton>
    </RequiresPermission>
  );
};

export const BotaoAbrirArquivo = ({ pushState, ...props }: any) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleClickAbrirArquivo = useCallback(() => {
    dispatch(abrirPaginaArquivos("ABRIR"));
    history.push("/arquivos", pushState);
  }, [dispatch, history, pushState]);

  return (
    <OkButton
      {...props}
      className="Rodape__botao"
      onClick={handleClickAbrirArquivo}
    >
      <Translate>configuracaoRelatorio.botaoAbrir</Translate>
    </OkButton>
  );
};

export const BotaoSalvarArquivo = (props: *) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleClickSalvarArquivo = useCallback(() => {
    dispatch(abrirPaginaArquivos("SALVAR"));
    history.push("/arquivos");
  }, [dispatch, history]);

  return (
    <OkButton
      {...props}
      className="Rodape__botao"
      onClick={handleClickSalvarArquivo}
    >
      <Translate>configuracaoRelatorio.botaoSalvar</Translate>
    </OkButton>
  );
};

export const BotaoLimparMedidas = () => {
  const dispatch = useDispatch();

  const handleClickLimparMedidas = useCallback(
    () => dispatch(limparSelecao()),
    [dispatch]
  );

  return (
    <RejectButton
      className="Rodape__botao Rodape__botao--limpar"
      onClick={handleClickLimparMedidas}
    >
      <Translate>configuracaoRelatorio.botaoLimpar</Translate>
    </RejectButton>
  );
};

export const BotaoEnviarMedidasParaExcel = (props: *) => {
  const dispatch = useDispatch();

  const handleClickEnviarMedidas = useCallback(() => {
    dispatch({ type: "ENVIAR_MEDIDAS_PARA_EXCEL" });
  }, [dispatch]);

  return (
    <OkButton
      {...props}
      className="Rodape__botao"
      onClick={handleClickEnviarMedidas}
    >
      <Translate>Comum.Ok</Translate>
    </OkButton>
  );
};

type Props = {
  modoApp: ModoApp,
};

const Rodape = ({ modoApp }: Props) => {
  const dispatch = useDispatch();
  const { open: abrirModalQtLink } = useModal("qtlink");

  const handleClickAbrirModalQtLink = useCallback(
    () => dispatch(abrirExplicacaoQtLink()),
    [dispatch]
  );

  const handleClickExportarVinculado = useCallback(
    () => dispatch(exportarExcelVinculado()),
    [dispatch]
  );

  const handleClickExportarFuncao = useCallback(() => {
    dispatch(exportarFuncaoQtlink());
    abrirModalQtLink();
  }, [dispatch, abrirModalQtLink]);

  const handleClickGerarRelatorio = useCallback(() => {
    dispatch(gerarRelatorio());
  }, [dispatch]);

  return (
    <>
      <div className="Rodape">
        <BotaoTemplate />
        <BotaoAbrirArquivo />
        <BotaoSalvarArquivo />
        <BotaoLimparMedidas />

        <IconButton
          className="Rodape__botao Rodape__botao--quantum-link"
          icon={<img src={IconeQuantumLink} alt="Ícone Quantum Link" />}
          onClick={handleClickAbrirModalQtLink}
        >
          <Translate>QuantumLink.titulo</Translate>
        </IconButton>

        <RequiresPermission permission="EXPORTAR_EXCEL_VINCULADO">
          <OkButton
            className="Rodape__botao"
            onClick={handleClickExportarVinculado}
          >
            <Translate>configuracaoRelatorio.botaoExportarVinculado</Translate>
          </OkButton>
        </RequiresPermission>

        {modoApp === MODO_APP_NORMAL && (
          <RequiresPermission permission="EXPORTAR_EXCEL_VINCULADO">
            <RequiresPermission permission="EXPORTAR_EXCEL_COMPLETO">
              <OkButton
                className="Rodape__botao"
                onClick={handleClickExportarFuncao}
              >
                <Translate>configuracaoRelatorio.botaoExportarFuncao</Translate>
              </OkButton>
            </RequiresPermission>
          </RequiresPermission>
        )}

        <OkButton className="Rodape__botao" onClick={handleClickGerarRelatorio}>
          <Translate>configuracaoRelatorio.botaoOk</Translate>
        </OkButton>

        <a
          className="Rodape__link-layout-antigo"
          href={
            modoApp === MODO_APP_SERIES
              ? "/webaxis/wait.jsp?gotopage=dadosIndustria.qt&cmd=carregarTela&tela=dadosIndustria"
              : "/webaxis/wait.jsp?gotopage=telaPersonalizada.jsp"
          }
        >
          <Translate>telas.layoutAntigo</Translate>
        </a>
      </div>

      <div className="Disclaimer">
        <div className="Disclaimer__barra" />
        <div className="Disclaimer__mensagem">
          2005 | <b>QUANTUM</b> |{" "}
          <Translate replacements={["QUANTUM"]}>telas.direitos</Translate>{" "}
          <a
            target="_blank"
            href="/webaxis/termosEcondicoes.jsp"
            className="Disclaimer__termos"
          >
            <Translate>telas.termosCondicoes</Translate>
          </a>
          .
        </div>
      </div>
    </>
  );
};

export default connect(
  (state: State) => ({
    modoApp: getModoApp(state),
  }),
  null
)(Rodape);
